<template>
  <div class="d-flex flex-column fill-height">
    <div
      class="fill-height"
      id="messages-container"
      style="overflow: auto;"
    >
      <Messages :messages="$store.state.storage.room.chat" />
    </div>
    <v-slide-y-transition>
      <v-sheet
        color="white"
        elevation="4"
      >
        <TextField
          @sendMessage="sendMessage"
          @showAttachments="$refs.attachments.show()"
          @sendAttachmentClipBoard="sendAttachment"
          v-if="show"
        />
        <Attachments
          ref="attachments"
          @sendAttachment="sendAttachment"
        />
      </v-sheet>
    </v-slide-y-transition>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    TextField: () => import(/* webpackPrefetch: true */ '@/views/session/components/chat/resources/TextField.vue'),
    Messages: () => import(/* webpackPrefetch: true */ '@/views/session/components/chat/resources/Messages.vue'),
    Attachments: () => import(/* webpackPrefetch: true */ '@/views/session/components/chat/resources/attachments/Index.vue')
  },
  props: {
    session: {
      type: OT.Session,
      required: true
    },
    awsS3Url: {
      type: String,
      default: process.env.VUE_APP_AWS_S3_URL
    },
    show: {
      type: Boolean,
      default: false
    }
  }
})
export default class Index extends Vue {
  data () {
    return {
      messages: []
    }
  }

  mounted () {
    this.initMsgSignal()
  }

  notifyMessage () {
    if (this.$organization.allowChatForUser()) {
      if (!this.show) {
        this.$parent.chat.unreadMessages++
      }
      this.playMessageSound()
    }
  }

  playMessageSound () {
    const audio = new Audio('/sounds/App_Message.mp3')
    audio.volume = 1
    audio.play()
  }

  isValidUrl (url) {
    const regexQuery = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi
    const regex = new RegExp(regexQuery)
    return regex.test(url)
  }

  addBlankTargets (s) {
    return ('' + s).replace(/<a\s+href=/gi, '<a target="_blank" href=')
  }

  saveMessage (message) {
    this.$store.state.storage.room.chat.push(message)
    this.$storage.updateStorageData()
  }

  fileDownloadLink (link, fileName) {
    const containerElement = document.createElement('div')
    containerElement.style['position'] = 'absolute'
    containerElement.style['bottom'] = '2px'
    containerElement.style['right'] = '0px'

    const aElement = document.createElement('a')

    aElement.href = link
    aElement.id = 'chat-file-link'
    aElement.innerHTML = '<small>Ver archivo</small>'
    aElement.target = '_blank'
    aElement.download = true
    aElement.title = fileName
    aElement.style['background'] = 'rgba(0, 0, 0, 0.7)'
    aElement.style['text-decoration'] = 'none'
    aElement.style['padding'] = '3px 10px'
    aElement.style['border-radius'] = '10px'
    aElement.style['color'] = 'white'

    containerElement.appendChild(aElement)

    return containerElement.outerHTML
  }

  imageMessage (path, fileName, extension) {
    const imgElement = document.createElement('img')

    imgElement.src = `${path}/${fileName}-thumbnail.${extension}`
    imgElement.alt = `ocularSolution chat image - ${fileName}`
    imgElement.style['object-fit'] = 'cover'
    imgElement.style['width'] = '150px'
    imgElement.style['border-radius'] = '5px'

    return `${imgElement.outerHTML} ${this.fileDownloadLink(`${path}/${fileName}.${extension}`, fileName)}`
  }

  videoMessage (path, fileName, extension) {
    const videoElement = document.createElement('video')

    videoElement.src = `${path}/${fileName}.${extension}`
    videoElement.style['width'] = '200px'
    videoElement.controls = true
    videoElement.style['border-radius'] = '5px'

    return `${videoElement.outerHTML} ${this.fileDownloadLink(`${path}/${fileName}.${extension}`, fileName)}`
  }

  audioMessage (path, fileName, extension) {
    const audioElement = document.createElement('audio')

    audioElement.src = `${path}/${fileName}.${extension}`
    audioElement.style['width'] = '216px'
    audioElement.controls = true

    return `${audioElement.outerHTML} ${this.fileDownloadLink(`${path}/${fileName}.${extension}`, fileName)}`
  }

  fileMessage (path, fileName, extension) {
    const containerElement = document.createElement('div')

    containerElement.style['width'] = '120px'
    containerElement.style['padding'] = '15px 0px 34px'
    containerElement.style['margin'] = '0 auto'

    const fileElement = document.createElement('div')

    fileElement.style['width'] = '30px'
    fileElement.style['height'] = '30px'
    fileElement.style['margin'] = '0 auto'

    const imgIconElement = document.createElement('img')

    if (extension === 'pdf') {
      imgIconElement.src = `${this.awsS3Url}/images/chat/ocular-chat-pdf-icon.png`
    } else if (extension === 'rar') {
      imgIconElement.src = `${this.awsS3Url}/images/chat/ocular-chat-rar-icon.png`
    } else if (extension === 'xlsx') {
      imgIconElement.src = `${this.awsS3Url}/images/chat/ocular-chat-xls-icon.png`
    } else if (extension === 'docx') {
      imgIconElement.src = `${this.awsS3Url}/images/chat/ocular-chat-doc-icon.png`
    } else {
      imgIconElement.src = `${this.awsS3Url}/images/chat/ocular-chat-folder-icon.png`
    }

    imgIconElement.alt = `ocularSolution chat file - ${fileName}`
    imgIconElement.style['object-fit'] = 'cover'
    imgIconElement.style['width'] = '100%'
    imgIconElement.style['height'] = '100%'

    fileElement.appendChild(imgIconElement)
    containerElement.appendChild(fileElement)

    return `${containerElement.outerHTML} ${this.fileDownloadLink(`${path}/${fileName}.${extension}`, fileName)}`
  }

  sendAttachment (attachment) {
    const data = {
      message: 'Sin formato',
      type: 'file'
    }

    if (attachment.fileType === 'image') {
      data.message = this.imageMessage(attachment.filePath, attachment.fileName, attachment.extension)
    } else if (attachment.fileType === 'video') {
      data.message = this.videoMessage(attachment.filePath, attachment.fileName, attachment.extension)
    } else if (attachment.fileType === 'audio') {
      data.message = this.audioMessage(attachment.filePath, attachment.fileName, attachment.extension)
    } else {
      data.message = this.fileMessage(attachment.filePath, attachment.fileName, attachment.extension)
    }
    this.sendMessage(data.message, data.type)
  }

  setMessage (event) {
    const user = this.$store.state.storage.room.cammer.user
    const customer = this.$store.state.storage.room.customer

    const signal = (event.from.connectionId === this.session.connection.connectionId) ? 'mine' : 'their'

    const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data

    const message = {
      user: signal === 'their' ? user : customer,
      signal: signal,
      data: data.message,
      type: data.type,
      creationTime: new Date()
    }

    // if (message.type === 'message' && this.isValidUrl(message.data)) {
    //   let url = message.data
    //   url = (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) ? url : `https://${url}`
    //   message.data = message.data.link(url)
    //   message.data = this.addBlankTargets(`<b>${message.data}</b>`)
    // }

    this.saveMessage(message)
    return message
  }

  initMsgSignal () {
    if (this.$store.state.signal.msg && !this.$organization.allowChatForUser()) {
      return false
    }

    this.messages = []

    this.session.on('signal:msg', (event) => {
      this.setMessage(event)

      const signal = (event.from.connectionId === this.session.connection.connectionId) ? 'mine' : 'their'

      setTimeout(() => {
        const lastMessageElement = document.querySelector('#messages-container #chat-message:last-child')
        if (lastMessageElement) {
          lastMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' })
          if (signal === 'their') {
            this.notifyMessage()
          }
        }
      }, 200)
    })

    this.$store.state.signal.msg = true
  }

  convertLinksToAnchors (text) {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlPattern, (url) => `<a class="os-session-chat-link" target="_blank" href="${url}">${url}</a>`)
  }

  sendMessage (message, type) {
    if (!message) {
      return false
    }

    if (type === 'message') {
      message = this.convertLinksToAnchors(message)
    }

    const data = {
      message,
      type
    }

    this.session.signal({
        type: 'msg',
        data: JSON.stringify(data)
      }, (error) => {
        if (error) {
          console.log('Error sending signal - chat:', error.name, error.message)
        } else {
          message = ''
        }
      })
  }
}
</script>
